import { ReactNode } from 'react';
import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../../core/api/client/reactQueryConfig';

interface QueryClientProviderProps {
    children: ReactNode;
}

export const QueryClientProvider = ({ children }: QueryClientProviderProps) => {
    return <TanstackQueryClientProvider client={queryClient}>{children}</TanstackQueryClientProvider>;
};
